// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PayorPriority-module__font-s-10___gPHT8 {
  font-size: 10px !important;
}

.PayorPriority-module__font-s-12___hgWvm {
  font-size: 12px !important;
}

.PayorPriority-module__font-s-13___v0lxf {
  font-size: 13px !important;
}

.PayorPriority-module__font-s-14___d23jo {
  font-size: 14px !important;
}

.PayorPriority-module__font-s-15___uQw88 {
  font-size: 15px !important;
}

.PayorPriority-module__font-s-16___LQOWC {
  font-size: 16px !important;
}

.PayorPriority-module__font-s-18___wqdP9 {
  font-size: 18px !important;
}

.PayorPriority-module__font-s-20___fvozj {
  font-size: 20px !important;
}

.PayorPriority-module__font-s-22___Cc5Bp {
  font-size: 22px !important;
}

.PayorPriority-module__font-s-28___v11RD {
  font-size: 28px !important;
}

.PayorPriority-module__font-w-400___qLDDB {
  font-weight: 400 !important;
}

.PayorPriority-module__font-w-500___zTDhd {
  font-weight: 500 !important;
}

.PayorPriority-module__font-w-600___W5hbK {
  font-weight: 600 !important;
}

.PayorPriority-module__font-w-700___Ligwi {
  font-weight: 700 !important;
}

.PayorPriority-module__p-5___qn8s2 {
  padding: 5px !important;
}

.PayorPriority-module__p-12___afsnw {
  padding: 12px !important;
}

.PayorPriority-module__p-16___cAnW3 {
  padding: 16px !important;
}

.PayorPriority-module__p-30___nNR5b {
  padding: 30px !important;
}

.PayorPriority-module__p-b-0___XyUnw {
  padding-bottom: 0 !important;
}

.PayorPriority-module__p-b-5___S_UEl {
  padding-bottom: 5px !important;
}

.PayorPriority-module__p-b-10___r2gf3 {
  padding-bottom: 10px !important;
}

.PayorPriority-module__p-b-12___pFiu0 {
  padding-bottom: 12px !important;
}

.PayorPriority-module__p-b-16___VpfLq {
  padding-bottom: 16px !important;
}

.PayorPriority-module__p-b-18___sdLtJ {
  padding-bottom: 18px !important;
}

.PayorPriority-module__p-b-20___rlV0v {
  padding-bottom: 20px !important;
}

.PayorPriority-module__p-b-25___FS_GN {
  padding-bottom: 25px !important;
}

.PayorPriority-module__p-b-30___SvXeY {
  padding-bottom: 30px !important;
}

.PayorPriority-module__p-b-50___C5A_O {
  padding-bottom: 50px !important;
}

.PayorPriority-module__p-t-0___E9JEx {
  padding-top: 0 !important;
}

.PayorPriority-module__p-t-12___cfzyj {
  padding-top: 12px !important;
}

.PayorPriority-module__p-t-16___l2ZyM {
  padding-top: 16px !important;
}

.PayorPriority-module__p-t-18___D4GeJ {
  padding-top: 18px !important;
}

.PayorPriority-module__p-t-20___y92U5 {
  padding-top: 20px !important;
}

.PayorPriority-module__p-t-30___E1oSO {
  padding-top: 30px !important;
}

.PayorPriority-module__p-t-40___tPvej {
  padding-top: 40px !important;
}

.PayorPriority-module__p-t-50___jyrTG {
  padding-top: 50px !important;
}

.PayorPriority-module__p-l-20___WYH6S {
  padding-left: 20px !important;
}

.PayorPriority-module__p-l-30___DU4FJ {
  padding-left: 30px !important;
}

.PayorPriority-module__p-l-40___bBiZd {
  padding-left: 40px !important;
}

.PayorPriority-module__p-r-16___kA6VY {
  padding-right: 16px !important;
}

.PayorPriority-module__p-r-20___RSLKp {
  padding-right: 20px !important;
}

.PayorPriority-module__p-r-30___tLhzK {
  padding-right: 30px !important;
}

.PayorPriority-module__p-r-50___CfahN {
  padding-right: 50px !important;
}

.PayorPriority-module__p-r-60____Wqdp {
  padding-right: 60px !important;
}

.PayorPriority-module__m-b-1___uNv78 {
  margin-bottom: 1px !important;
}

.PayorPriority-module__m-b-2___XSmXk {
  margin-bottom: 2px !important;
}

.PayorPriority-module__m-b-6___Y1o2Q {
  margin-bottom: 6px !important;
}

.PayorPriority-module__m-b-8___yoTyy {
  margin-bottom: 8px !important;
}

.PayorPriority-module__m-b-10___ooMWX {
  margin-bottom: 10px !important;
}

.PayorPriority-module__m-b-14___U4llv {
  margin-bottom: 14px !important;
}

.PayorPriority-module__m-b-16____N0w0 {
  margin-bottom: 16px !important;
}

.PayorPriority-module__m-b-20___Sjx2M {
  margin-bottom: 20px !important;
}

.PayorPriority-module__m-b-22___flZN7 {
  margin-bottom: 22px !important;
}

.PayorPriority-module__m-b-24___jZWNx {
  margin-bottom: 24px !important;
}

.PayorPriority-module__m-b-30___BlkZi {
  margin-bottom: 30px !important;
}

.PayorPriority-module__m-b-32____QC85 {
  margin-bottom: 32px !important;
}

.PayorPriority-module__m-b-40___L3aRr {
  margin-bottom: 40px !important;
}

.PayorPriority-module__m-t-2___NaQcf {
  margin-top: 2px !important;
}

.PayorPriority-module__m-t-3___W5pUn {
  margin-top: 3px !important;
}

.PayorPriority-module__m-t-4___Xh6Ds {
  margin-top: 4px !important;
}

.PayorPriority-module__m-t-5___GOX7R {
  margin-top: 5px !important;
}

.PayorPriority-module__m-t-8___IBFg1 {
  margin-top: 8px !important;
}

.PayorPriority-module__m-t-10___vIUMe {
  margin-top: 10px !important;
}

.PayorPriority-module__m-t-15___BGy3J {
  margin-top: 15px !important;
}

.PayorPriority-module__m-t-16___Tp73d {
  margin-top: 16px !important;
}

.PayorPriority-module__m-t-20___W1NXc {
  margin-top: 20px !important;
}

.PayorPriority-module__m-t-22___SxHKh {
  margin-top: 22px !important;
}

.PayorPriority-module__m-t-30___qT4fU {
  margin-top: 30px !important;
}

.PayorPriority-module__m-t-32___iMU0G {
  margin-top: 32px !important;
}

.PayorPriority-module__m-l-auto___LdaMd {
  margin-left: auto !important;
}

.PayorPriority-module__m-l-4___Q9iEc {
  margin-left: 4px !important;
}

.PayorPriority-module__m-l-5___kz232 {
  margin-left: 5px !important;
}

.PayorPriority-module__m-l-6___oFcUc {
  margin-left: 6px !important;
}

.PayorPriority-module__m-l-8___sWeqg {
  margin-left: 8px !important;
}

.PayorPriority-module__m-l-10___ZxggZ {
  margin-left: 10px !important;
}

.PayorPriority-module__m-l-16___NylXu {
  margin-left: 16px !important;
}

.PayorPriority-module__m-l-20___WaJ1D {
  margin-left: 20px !important;
}

.PayorPriority-module__m-l-24___HoBCg {
  margin-left: 24px !important;
}

.PayorPriority-module__m-l-30___Vd2pf {
  margin-left: 30px !important;
}

.PayorPriority-module__m-l-35___RVLaz {
  margin-left: 35px !important;
}

.PayorPriority-module__m-l-40___qCngb {
  margin-left: 40px !important;
}

.PayorPriority-module__m-r-8____J1mm {
  margin-right: 8px !important;
}

.PayorPriority-module__m-r-10___heF1L {
  margin-right: 10px !important;
}

.PayorPriority-module__m-r-16___CWDqA {
  margin-right: 16px !important;
}

.PayorPriority-module__m-r-20___h6TC6 {
  margin-right: 20px !important;
}

.PayorPriority-module__m-r-24___Sqsbl {
  margin-right: 24px !important;
}

.PayorPriority-module__m-r-30___HzlnS {
  margin-right: 30px !important;
}

.PayorPriority-module__m-r-40___UkizE {
  margin-right: 40px !important;
}

.PayorPriority-module__border-r-3___ZyCuV {
  border-radius: 3px !important;
}

.PayorPriority-module__border-r-4___iEFqd {
  border-radius: 4px !important;
}

.PayorPriority-module__border-r-6___RtQ9_ {
  border-radius: 6px !important;
}

.PayorPriority-module__border-r-10___riDVU {
  border-radius: 10px !important;
}

.PayorPriority-module__border-r-12___DAdS4 {
  border-radius: 12px !important;
}

.PayorPriority-module__border-r-16___HNQQb {
  border-radius: 16px !important;
}

.PayorPriority-module__border-r-50___Lz92s {
  border-radius: 50% !important;
}

.PayorPriority-module__primary-border___U2EPE {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.PayorPriority-module__primary-border-b___rOpnz {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.PayorPriority-module__primary-border-t___HOvTy {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.PayorPriority-module__primary-border-l___vpplk {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.PayorPriority-module__primary-border-r___oBL34 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.PayorPriority-module__secondary-border___kBfjl {
  border: 1px solid #637768;
}

.PayorPriority-module__secondary-border-b___osvuI {
  border-bottom: 1px solid #637768;
}

.PayorPriority-module__secondary-border-t___HWwJe {
  border-top: 1px solid #637768;
}

.PayorPriority-module__secondary-border-l___cpHra {
  border-left: 1px solid #637768;
}

.PayorPriority-module__secondary-border-r___Lne6_ {
  border-right: 1px solid #637768;
}

.PayorPriority-module__gap-0____vHvK {
  gap: 0 !important;
}

.PayorPriority-module__gap-2___HRwo9 {
  gap: 2px !important;
}

.PayorPriority-module__gap-4___vrx2Y {
  gap: 4px !important;
}

.PayorPriority-module__gap-5___Hk0Df {
  gap: 5px !important;
}

.PayorPriority-module__gap-6___tHroe {
  gap: 6px !important;
}

.PayorPriority-module__gap-8___MdhW_ {
  gap: 8px !important;
}

.PayorPriority-module__gap-10___whc0v {
  gap: 10px !important;
}

.PayorPriority-module__gap-12___kYjjo {
  gap: 12px !important;
}

.PayorPriority-module__gap-14___sAk_e {
  gap: 14px !important;
}

.PayorPriority-module__gap-16___QFgwF {
  gap: 16px !important;
}

.PayorPriority-module__gap-18___qggKg {
  gap: 18px !important;
}

.PayorPriority-module__gap-20___leziG {
  gap: 20px !important;
}

.PayorPriority-module__gap-24___vWees {
  gap: 24px !important;
}

.PayorPriority-module__gap-26___dy4nR {
  gap: 26px !important;
}

.PayorPriority-module__gap-30___Kfhri {
  gap: 30px !important;
}

.PayorPriority-module__gap-32___iGw58 {
  gap: 32px !important;
}

.PayorPriority-module__gap-40___PFYzx {
  gap: 40px !important;
}

.PayorPriority-module__gap-50___uMSwp {
  gap: 50px !important;
}

.PayorPriority-module__flex-1___Ql4xE {
  flex: 1;
}

.PayorPriority-module__flex-none___IEMLw {
  flex: none !important;
}

.PayorPriority-module__flex-column___qb46w {
  display: flex;
  flex-direction: column !important;
}

.PayorPriority-module__flex-row___AYPTq {
  display: flex;
  flex-direction: row !important;
}

.PayorPriority-module__vertically-centered___Ieq5b {
  display: flex;
  align-items: center !important;
}

.PayorPriority-module__horizontally-centered___ySPeC {
  display: flex;
  justify-content: center !important;
}

.PayorPriority-module__horizontally-end___IOQA6 {
  display: flex;
  justify-content: end !important;
}

.PayorPriority-module__vertically-start____apfI {
  display: flex;
  align-items: start !important;
}

.PayorPriority-module__space-between___iGII9 {
  display: flex;
  justify-content: space-between !important;
}

.PayorPriority-module__flex-wrap___ppSc4 {
  flex-wrap: wrap !important;
}

.PayorPriority-module__height-100___uGrUC {
  height: 100%;
}

.PayorPriority-module__width-50___ZriUu {
  width: 50% !important;
}

.PayorPriority-module__width-100___Cubsi {
  width: 100%;
}

.PayorPriority-module__cursor-pointer___x9Oe8 {
  cursor: pointer;
}

.PayorPriority-module__cursor-not-allowed___UN1cq {
  cursor: not-allowed !important;
}

.PayorPriority-module__absolute-centered___CyBlQ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.PayorPriority-module__absolute___XuJtJ {
  position: absolute;
}

.PayorPriority-module__relative___f50Ra {
  position: relative;
}

.PayorPriority-module__fixed___NBnxS {
  position: fixed;
}

.PayorPriority-module__visible___bjHKK {
  opacity: 1;
}

.PayorPriority-module__invisible___29e8O {
  opacity: 0;
}

.PayorPriority-module__col-90___culrV {
  width: 90% !important;
}

.PayorPriority-module__col-auto___tJxgI {
  width: auto !important;
}

.PayorPriority-module__medical-tabs___QB466 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.PayorPriority-module__medical-table-new___L1a4w {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PayorPriority-module__medical-table-new___L1a4w:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PayorPriority-module__medical-table-new___L1a4w::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PayorPriority-module__medical-table-new___L1a4w::-webkit-scrollbar-track {
  display: none;
}
.PayorPriority-module__medical-table-new___L1a4w.PayorPriority-module__no-pagination___OHrx2 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PayorPriority-module__medical-table-new___L1a4w.PayorPriority-module__no-pagination___OHrx2:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PayorPriority-module__medical-table-new___L1a4w.PayorPriority-module__no-pagination___OHrx2::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PayorPriority-module__medical-table-new___L1a4w.PayorPriority-module__no-pagination___OHrx2::-webkit-scrollbar-track {
  display: none;
}

.PayorPriority-module__medical-table-empty___A1W6I {
  padding: 14px 40px !important;
}

.PayorPriority-module__icon-btn___VtYOH {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.PayorPriority-module__search-icon___qRAC9 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.PayorPriority-module__disable-select___PYOkt {
  user-select: none;
}

.PayorPriority-module__break-word___zxCFE {
  word-break: break-word;
}

.PayorPriority-module__popup-clear-btn___bflyj {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.PayorPriority-module__scroll-m-b-20___t0_dS {
  scroll-margin-bottom: 20px;
}

.PayorPriority-module__tableCell___FoisS {
  padding: 8px 0;
}

.PayorPriority-module__subheader___Rnb63 {
  height: 58px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 30px;
}
.PayorPriority-module__subheader___Rnb63 .PayorPriority-module__dateContainer___JAy6U {
  display: flex;
  align-items: center;
  gap: 10px;
}
.PayorPriority-module__subheader___Rnb63 .PayorPriority-module__dateContainer___JAy6U .PayorPriority-module__text___EWJLJ {
  color: #375844;
  font-size: 14px;
}
.PayorPriority-module__subheader___Rnb63 .PayorPriority-module__dateContainer___JAy6U .PayorPriority-module__select___pGWta {
  width: 200px;
}
.PayorPriority-module__subheader___Rnb63 .PayorPriority-module__dateContainer___JAy6U .PayorPriority-module__pickerContainer___a_WjT {
  width: 0 !important;
  height: 0 !important;
}
.PayorPriority-module__subheader___Rnb63 .PayorPriority-module__dateContainer___JAy6U .PayorPriority-module__pickerInput___iksQM {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/PayorPriority/PayorPriority.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA8pBJ;AA5pBI;EACE,cAAA;EACA,eAAA;AA8pBN;AA3pBI;EACE,YAAA;AA6pBN;AA1pBI;EACE,mBAAA;EACA,oBAAA;AA4pBN;AAzpBI;EACE,aAAA;AA2pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.tableCell {\n  padding: 8px 0;\n}\n\n.subheader {\n  height: 58px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 30px;\n\n  .dateContainer {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    .text {\n      color: get-color(greenNew, dark);\n      font-size: 14px;\n    }\n\n    .select {\n      width: 200px;\n    }\n\n    .pickerContainer {\n      width: 0 !important;\n      height: 0 !important;\n    }\n\n    .pickerInput {\n      display: none;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `PayorPriority-module__font-s-10___gPHT8`,
	"fontS12": `PayorPriority-module__font-s-12___hgWvm`,
	"fontS13": `PayorPriority-module__font-s-13___v0lxf`,
	"fontS14": `PayorPriority-module__font-s-14___d23jo`,
	"fontS15": `PayorPriority-module__font-s-15___uQw88`,
	"fontS16": `PayorPriority-module__font-s-16___LQOWC`,
	"fontS18": `PayorPriority-module__font-s-18___wqdP9`,
	"fontS20": `PayorPriority-module__font-s-20___fvozj`,
	"fontS22": `PayorPriority-module__font-s-22___Cc5Bp`,
	"fontS28": `PayorPriority-module__font-s-28___v11RD`,
	"fontW400": `PayorPriority-module__font-w-400___qLDDB`,
	"fontW500": `PayorPriority-module__font-w-500___zTDhd`,
	"fontW600": `PayorPriority-module__font-w-600___W5hbK`,
	"fontW700": `PayorPriority-module__font-w-700___Ligwi`,
	"p5": `PayorPriority-module__p-5___qn8s2`,
	"p12": `PayorPriority-module__p-12___afsnw`,
	"p16": `PayorPriority-module__p-16___cAnW3`,
	"p30": `PayorPriority-module__p-30___nNR5b`,
	"pB0": `PayorPriority-module__p-b-0___XyUnw`,
	"pB5": `PayorPriority-module__p-b-5___S_UEl`,
	"pB10": `PayorPriority-module__p-b-10___r2gf3`,
	"pB12": `PayorPriority-module__p-b-12___pFiu0`,
	"pB16": `PayorPriority-module__p-b-16___VpfLq`,
	"pB18": `PayorPriority-module__p-b-18___sdLtJ`,
	"pB20": `PayorPriority-module__p-b-20___rlV0v`,
	"pB25": `PayorPriority-module__p-b-25___FS_GN`,
	"pB30": `PayorPriority-module__p-b-30___SvXeY`,
	"pB50": `PayorPriority-module__p-b-50___C5A_O`,
	"pT0": `PayorPriority-module__p-t-0___E9JEx`,
	"pT12": `PayorPriority-module__p-t-12___cfzyj`,
	"pT16": `PayorPriority-module__p-t-16___l2ZyM`,
	"pT18": `PayorPriority-module__p-t-18___D4GeJ`,
	"pT20": `PayorPriority-module__p-t-20___y92U5`,
	"pT30": `PayorPriority-module__p-t-30___E1oSO`,
	"pT40": `PayorPriority-module__p-t-40___tPvej`,
	"pT50": `PayorPriority-module__p-t-50___jyrTG`,
	"pL20": `PayorPriority-module__p-l-20___WYH6S`,
	"pL30": `PayorPriority-module__p-l-30___DU4FJ`,
	"pL40": `PayorPriority-module__p-l-40___bBiZd`,
	"pR16": `PayorPriority-module__p-r-16___kA6VY`,
	"pR20": `PayorPriority-module__p-r-20___RSLKp`,
	"pR30": `PayorPriority-module__p-r-30___tLhzK`,
	"pR50": `PayorPriority-module__p-r-50___CfahN`,
	"pR60": `PayorPriority-module__p-r-60____Wqdp`,
	"mB1": `PayorPriority-module__m-b-1___uNv78`,
	"mB2": `PayorPriority-module__m-b-2___XSmXk`,
	"mB6": `PayorPriority-module__m-b-6___Y1o2Q`,
	"mB8": `PayorPriority-module__m-b-8___yoTyy`,
	"mB10": `PayorPriority-module__m-b-10___ooMWX`,
	"mB14": `PayorPriority-module__m-b-14___U4llv`,
	"mB16": `PayorPriority-module__m-b-16____N0w0`,
	"mB20": `PayorPriority-module__m-b-20___Sjx2M`,
	"mB22": `PayorPriority-module__m-b-22___flZN7`,
	"mB24": `PayorPriority-module__m-b-24___jZWNx`,
	"mB30": `PayorPriority-module__m-b-30___BlkZi`,
	"mB32": `PayorPriority-module__m-b-32____QC85`,
	"mB40": `PayorPriority-module__m-b-40___L3aRr`,
	"mT2": `PayorPriority-module__m-t-2___NaQcf`,
	"mT3": `PayorPriority-module__m-t-3___W5pUn`,
	"mT4": `PayorPriority-module__m-t-4___Xh6Ds`,
	"mT5": `PayorPriority-module__m-t-5___GOX7R`,
	"mT8": `PayorPriority-module__m-t-8___IBFg1`,
	"mT10": `PayorPriority-module__m-t-10___vIUMe`,
	"mT15": `PayorPriority-module__m-t-15___BGy3J`,
	"mT16": `PayorPriority-module__m-t-16___Tp73d`,
	"mT20": `PayorPriority-module__m-t-20___W1NXc`,
	"mT22": `PayorPriority-module__m-t-22___SxHKh`,
	"mT30": `PayorPriority-module__m-t-30___qT4fU`,
	"mT32": `PayorPriority-module__m-t-32___iMU0G`,
	"mLAuto": `PayorPriority-module__m-l-auto___LdaMd`,
	"mL4": `PayorPriority-module__m-l-4___Q9iEc`,
	"mL5": `PayorPriority-module__m-l-5___kz232`,
	"mL6": `PayorPriority-module__m-l-6___oFcUc`,
	"mL8": `PayorPriority-module__m-l-8___sWeqg`,
	"mL10": `PayorPriority-module__m-l-10___ZxggZ`,
	"mL16": `PayorPriority-module__m-l-16___NylXu`,
	"mL20": `PayorPriority-module__m-l-20___WaJ1D`,
	"mL24": `PayorPriority-module__m-l-24___HoBCg`,
	"mL30": `PayorPriority-module__m-l-30___Vd2pf`,
	"mL35": `PayorPriority-module__m-l-35___RVLaz`,
	"mL40": `PayorPriority-module__m-l-40___qCngb`,
	"mR8": `PayorPriority-module__m-r-8____J1mm`,
	"mR10": `PayorPriority-module__m-r-10___heF1L`,
	"mR16": `PayorPriority-module__m-r-16___CWDqA`,
	"mR20": `PayorPriority-module__m-r-20___h6TC6`,
	"mR24": `PayorPriority-module__m-r-24___Sqsbl`,
	"mR30": `PayorPriority-module__m-r-30___HzlnS`,
	"mR40": `PayorPriority-module__m-r-40___UkizE`,
	"borderR3": `PayorPriority-module__border-r-3___ZyCuV`,
	"borderR4": `PayorPriority-module__border-r-4___iEFqd`,
	"borderR6": `PayorPriority-module__border-r-6___RtQ9_`,
	"borderR10": `PayorPriority-module__border-r-10___riDVU`,
	"borderR12": `PayorPriority-module__border-r-12___DAdS4`,
	"borderR16": `PayorPriority-module__border-r-16___HNQQb`,
	"borderR50": `PayorPriority-module__border-r-50___Lz92s`,
	"primaryBorder": `PayorPriority-module__primary-border___U2EPE`,
	"primaryBorderB": `PayorPriority-module__primary-border-b___rOpnz`,
	"primaryBorderT": `PayorPriority-module__primary-border-t___HOvTy`,
	"primaryBorderL": `PayorPriority-module__primary-border-l___vpplk`,
	"primaryBorderR": `PayorPriority-module__primary-border-r___oBL34`,
	"secondaryBorder": `PayorPriority-module__secondary-border___kBfjl`,
	"secondaryBorderB": `PayorPriority-module__secondary-border-b___osvuI`,
	"secondaryBorderT": `PayorPriority-module__secondary-border-t___HWwJe`,
	"secondaryBorderL": `PayorPriority-module__secondary-border-l___cpHra`,
	"secondaryBorderR": `PayorPriority-module__secondary-border-r___Lne6_`,
	"gap0": `PayorPriority-module__gap-0____vHvK`,
	"gap2": `PayorPriority-module__gap-2___HRwo9`,
	"gap4": `PayorPriority-module__gap-4___vrx2Y`,
	"gap5": `PayorPriority-module__gap-5___Hk0Df`,
	"gap6": `PayorPriority-module__gap-6___tHroe`,
	"gap8": `PayorPriority-module__gap-8___MdhW_`,
	"gap10": `PayorPriority-module__gap-10___whc0v`,
	"gap12": `PayorPriority-module__gap-12___kYjjo`,
	"gap14": `PayorPriority-module__gap-14___sAk_e`,
	"gap16": `PayorPriority-module__gap-16___QFgwF`,
	"gap18": `PayorPriority-module__gap-18___qggKg`,
	"gap20": `PayorPriority-module__gap-20___leziG`,
	"gap24": `PayorPriority-module__gap-24___vWees`,
	"gap26": `PayorPriority-module__gap-26___dy4nR`,
	"gap30": `PayorPriority-module__gap-30___Kfhri`,
	"gap32": `PayorPriority-module__gap-32___iGw58`,
	"gap40": `PayorPriority-module__gap-40___PFYzx`,
	"gap50": `PayorPriority-module__gap-50___uMSwp`,
	"flex1": `PayorPriority-module__flex-1___Ql4xE`,
	"flexNone": `PayorPriority-module__flex-none___IEMLw`,
	"flexColumn": `PayorPriority-module__flex-column___qb46w`,
	"flexRow": `PayorPriority-module__flex-row___AYPTq`,
	"verticallyCentered": `PayorPriority-module__vertically-centered___Ieq5b`,
	"horizontallyCentered": `PayorPriority-module__horizontally-centered___ySPeC`,
	"horizontallyEnd": `PayorPriority-module__horizontally-end___IOQA6`,
	"verticallyStart": `PayorPriority-module__vertically-start____apfI`,
	"spaceBetween": `PayorPriority-module__space-between___iGII9`,
	"flexWrap": `PayorPriority-module__flex-wrap___ppSc4`,
	"height100": `PayorPriority-module__height-100___uGrUC`,
	"width50": `PayorPriority-module__width-50___ZriUu`,
	"width100": `PayorPriority-module__width-100___Cubsi`,
	"cursorPointer": `PayorPriority-module__cursor-pointer___x9Oe8`,
	"cursorNotAllowed": `PayorPriority-module__cursor-not-allowed___UN1cq`,
	"absoluteCentered": `PayorPriority-module__absolute-centered___CyBlQ`,
	"absolute": `PayorPriority-module__absolute___XuJtJ`,
	"relative": `PayorPriority-module__relative___f50Ra`,
	"fixed": `PayorPriority-module__fixed___NBnxS`,
	"visible": `PayorPriority-module__visible___bjHKK`,
	"invisible": `PayorPriority-module__invisible___29e8O`,
	"col90": `PayorPriority-module__col-90___culrV`,
	"colAuto": `PayorPriority-module__col-auto___tJxgI`,
	"medicalTabs": `PayorPriority-module__medical-tabs___QB466`,
	"medicalTableNew": `PayorPriority-module__medical-table-new___L1a4w`,
	"noPagination": `PayorPriority-module__no-pagination___OHrx2`,
	"medicalTableEmpty": `PayorPriority-module__medical-table-empty___A1W6I`,
	"iconBtn": `PayorPriority-module__icon-btn___VtYOH`,
	"searchIcon": `PayorPriority-module__search-icon___qRAC9`,
	"disableSelect": `PayorPriority-module__disable-select___PYOkt`,
	"breakWord": `PayorPriority-module__break-word___zxCFE`,
	"popupClearBtn": `PayorPriority-module__popup-clear-btn___bflyj`,
	"scrollMB20": `PayorPriority-module__scroll-m-b-20___t0_dS`,
	"tableCell": `PayorPriority-module__tableCell___FoisS`,
	"subheader": `PayorPriority-module__subheader___Rnb63`,
	"dateContainer": `PayorPriority-module__dateContainer___JAy6U`,
	"text": `PayorPriority-module__text___EWJLJ`,
	"select": `PayorPriority-module__select___pGWta`,
	"pickerContainer": `PayorPriority-module__pickerContainer___a_WjT`,
	"pickerInput": `PayorPriority-module__pickerInput___iksQM`
};
module.exports = ___CSS_LOADER_EXPORT___;
